import React from "react";

const VirtualslipsIcon = props => {
  const color = props.color;
  return (
    <svg
      width={20}
      height={16}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>baseline-confirmation_number-24px</title>
      <defs>
        <path fill={color} id="a" d="M0 0h24v24H0z" />
      </defs>
      <g transform="translate(-2 -4)" fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill={color}
          d="M22 10V6a2 2 0 0 0-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2a2 2 0 0 1-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
          fillRule="nonzero"
          mask="url(#b)"
        />
      </g>
    </svg>
  );
};
export default VirtualslipsIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/VirtualslipsIcon.js